var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{class:[
    _vm.$style.collapseCaret,
    _vm.collapsed ? _vm.$style.collapsed : _vm.$style.notCollapsed
  ],attrs:{"icon":"chevronUp","scale":0.75}})
}
var staticRenderFns = []

export { render, staticRenderFns }